module.exports = __webpack_public_path__ + "assets/brand-standard-filter.6925b9d8.svg";